import React, { useEffect, useState } from "react";
import "./style.css";

import { useAlert } from "../../../context/AlertContext";

import Loading from "../../../components/Loading";
import { adicionarPessoaAutorizada } from "../../../api/requisicoes/pessoas";

import iconeAgenda from "../../../assets/icone-agenda.webp";

const AgendamentoMobile = ({ setActiveComponent }) => {
    const [nomeCompleto, setNomeCompleto] = useState("");
    const [empresa, setEmpresa] = useState("");
    const [responsavel, setResponsavel] = useState("");
    const [dataVisita, setDataVisita] = useState("");
    const [horarioVisita, setHorarioVisita] = useState("");
    const [usuario, setUsuario] = useState("");

    const nomeCompletoUsuario = localStorage.getItem("fullName") || "";

    useEffect(() => {
        setResponsavel(nomeCompletoUsuario);
    }, []);

    const aguardarAnimacao = () => {
        return new Promise((resolve) => setTimeout(resolve, 200));
    };

    const { showAlert } = useAlert();

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const userId = localStorage.getItem("userId");
        setUsuario(userId);
    }, [usuario, showAlert]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!usuario) {
            showAlert(
                "Usuário não encontrado. Certifique-se de estar autenticado.",
                "erro"
            );
            return;
        }

        const dados = {
            nomeCompleto,
            empresa,
            responsavel,
            dataVisita,
            horarioVisita,
            usuario,
        };

        try {
            setLoading(true);
            await adicionarPessoaAutorizada(dados);
            showAlert("Visitante agendado com sucesso!", "sucesso");
            // Limpa os campos do formulário após o envio
            setNomeCompleto("");
            setEmpresa("");
            setResponsavel("");
            setDataVisita("");
            setHorarioVisita("");
        } catch (error) {
            if (error.response) {
                showAlert(`Erro! ${error.response.data.error}.`, "erro");
            } else {
                showAlert(
                    "Erro desconhecido, contate o administrador do sistema!",
                    "erro"
                );
            }
        } finally {
            setLoading(false);
        }
    };

    const navegarParaAgendados = async () => {
        await aguardarAnimacao();
        setActiveComponent("visitantes-agendados");
    };
    return (
        <div className="tela-mobile-agenda coluna">
            {loading && <Loading />}
            <div className="agendamentoMobile-header">
                <h1>Agenda de Visitantes</h1>
                <div
                    className="agendamentoMobile-icone-agenda"
                    onClick={navegarParaAgendados}
                    role="button"
                >
                    <img src={iconeAgenda} alt="Visitantes Agendados"></img>
                </div>
            </div>
            <div className="formulario coluna">
                <div className="entrada coluna">
                    <label>Nome completo</label>
                    <input
                        type="text"
                        id="nomeCompleto"
                        name="nomeCompleto"
                        value={nomeCompleto}
                        onChange={(e) => setNomeCompleto(e.target.value)}
                        onBlur={(e) =>
                            setNomeCompleto(e.target.value.toUpperCase())
                        }
                        required
                    />
                </div>
                <div className="entrada coluna">
                    <label>Empresa</label>
                    <input
                        type="text"
                        id="empresa"
                        name="empresa"
                        value={empresa}
                        onChange={(e) => setEmpresa(e.target.value)}
                        onBlur={(e) => setEmpresa(e.target.value.toUpperCase())}
                        required
                    />
                </div>
                <div className="entrada coluna">
                    <label>Responsável</label>
                    <input
                        type="text"
                        id="responsavel"
                        name="responsavel"
                        value={responsavel}
                        onChange={(e) => setResponsavel(e.target.value)}
                        onBlur={(e) =>
                            setResponsavel(e.target.value.toUpperCase())
                        }
                        required
                    ></input>
                </div>
                <div className="data-hora linha">
                    <div className="entrada coluna data">
                        <label>Data</label>
                        <input
                            type="date"
                            id="data"
                            name="data"
                            value={dataVisita}
                            onChange={(e) => setDataVisita(e.target.value)}
                            required
                        ></input>
                    </div>
                    <div className="entrada coluna hora">
                        <label>Horário</label>
                        <input
                            type="time"
                            id="horario"
                            name="horario"
                            value={horarioVisita}
                            onChange={(e) => setHorarioVisita(e.target.value)}
                            required
                        ></input>
                    </div>
                </div>
            </div>
            <div className="botao linha">
                <button onClick={handleSubmit}>Agendar</button>
            </div>
        </div>
    );
};

export default AgendamentoMobile;
